import React from 'react';

import '../styles/quote.css';

export default class QuotesController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quotes: []
    };
  }

  componentWillMount() {
    const that = this;
    fetch('/api/notes', {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'GET'
    }).then(res => {
      res.json().then((notes) => {
        const filtered = notes.filter((n) => n.type === 'quote');
        that.setState({quotes: filtered});
      });
    });
  }

  render() {
    return (<div>
      {this.state.quotes.map((quote) => (
        <div className='quote-item' key={quote.id}>
          <blockquote>
            {quote.content}
            <span>{quote.source}</span>
          </blockquote>
        </div>
      ))}
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/QuotesController.js